// @flow
import * as ActionTypes from '../../constants/ActionTypes';

export const adminGetAllSubscriptions = (req) => ({
  type: ActionTypes.ADMIN_GET_ALL_SUBSCRIPTIONS_START,
  payload: req,
});

export const adminGetAllSubscriptionsSuccess = (data) => {
  return {
    type: ActionTypes.ADMIN_GET_ALL_SUBSCRIPTIONS_SUCCESS,
    payload: data,
  };
};
export const adminGetAllSubscriptionsFailure = (error) => ({
  type: ActionTypes.ADMIN_GET_ALL_SUBSCRIPTIONS_FAILURE,
  payload: error,
});

export const adminAddSubscriptionPlan = (reqData) => ({
  type: ActionTypes.ADMIN_ADD_SUBSCRIPTION_PLAN_START,
  payload: reqData,
});

export const adminAddSubscriptionPlanSuccess = (data) => {
  return {
    type: ActionTypes.ADMIN_ADD_SUBSCRIPTION_PLAN_SUCCESS,
    payload: data,
  };
};

export const adminAddSubscriptionPlanFailure = (error) => ({
  type: ActionTypes.ADMIN_ADD_SUBSCRIPTION_PLAN_FAILURE,
  payload: error,
});

export const adminUpdateStatusSubscription = (req) => ({
  type: ActionTypes.ADMIN_UPDATE_STATUS_SUBSCRIPTION_PLAN_START,
  payload: req,
});

export const adminUpdateStatusSubscriptionSuccess = (data) => {
  return {
    type: ActionTypes.ADMIN_UPDATE_STATUS_SUBSCRIPTION_PLAN_SUCCESS,
    payload: data,
  };
};
export const adminUpdateStatusSubscriptionFailure = (error) => ({
  type: ActionTypes.ADMIN_UPDATE_STATUS_SUBSCRIPTION_PLAN_FAILURE,
  payload: error,
});
